var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomepageReason4 = function SvgHomepageReason4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 90,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "homepage-reason4_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.256 90V70.672H.76V60.048L40.824.4h16v57.984h11.648v12.288H56.824V90zM15.864 58.384h28.16V15.632z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F7",
    d: "M43.256 90V70.672H.76V60.048L40.824.4h16v57.984h11.648v12.288H56.824V90zM15.864 58.384h28.16V15.632z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D1D6",
    d: "M43.256 90h-2v2h2zm0-19.328h2v-2h-2zm-42.496 0h-2v2h2zm0-10.624L-.9 58.933l-.34.506v.609zM40.824.4v-2h-1.066l-.594.885zm16 0h2v-2h-2zm0 57.984h-2v2h2zm11.648 0h2v-2h-2zm0 12.288v2h2v-2zm-11.648 0v-2h-2v2zm0 19.328v2h2v-2zm-40.96-31.616-1.67-1.1-2.042 3.1h3.712zm28.16 0v2h2v-2zm0-42.752h2V8.96l-3.67 5.572zM45.256 90V70.672h-4V90zm-2-21.328H.76v4h42.496zm-40.496 2V60.048h-4v10.624zm-.34-9.509L42.484 1.515l-3.32-2.23L-.9 58.933zM40.824 2.4h16v-4h-16zm14-2v57.984h4V.4zm2 59.984h11.648v-4H56.824zm9.648-2v12.288h4V58.384zm2 10.288H56.824v4h11.648zm-13.648 2V90h4V70.672zm2 17.328H43.256v4h13.568zm-40.96-27.616h28.16v-4h-28.16zm30.16-2V15.632h-4v42.752zm-3.67-43.852-28.16 42.752 3.34 2.2 28.16-42.752z",
    mask: "url(#homepage-reason4_svg__a)"
  })));
};
export default SvgHomepageReason4;